import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { issueSecurityLevelProjectsLimitsResource } from '@jira/router-resources__admin-pages-performance/src/issueSecurityLevelProjectsLimitsResource.tsx';
import { notFoundEntrypoint } from '@jira/spa-apps__error-pages-not-found/src/notFoundEntrypoint.entrypoint.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsPerformanceIssueSecurityLevelProjectLimitRoute } from '@jira/router-routes__admin-pages-performance-routes/src/globalSettingsPerformanceIssueSecurityLevelProjectLimitRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { issueSecurityLevelProjectLimitMetricDetailEntryPoint } from './ui/spa/admin-pages/performance/metric-detail/issue-security-level/project-limit/IssueSecurityLevelProjectLimitEntryPoint.tsx';

const notFoundPageEntrypoint = createPageEntryPoint({
	main: notFoundEntrypoint,
});

const getIssueSecurityLevelProjectLimitResources = () =>
	fg('slt1-1341_site_optimizer_add_cfo_isl_metrics')
		? [
				...getNavigationResources(),
				navigationSidebarGlobalResource,
				issueSecurityLevelProjectsLimitsResource,
			]
		: [...getNavigationResources(), navigationSidebarGlobalResource];

export const globalSettingsPerformanceIssueSecurityLevelProjectLimitRouteEntry: Route = createEntry(
	globalSettingsPerformanceIssueSecurityLevelProjectLimitRoute,
	() => ({
		group: 'global-settings',

		canTransitionIn: () => fg('slt1-1341_site_optimizer_add_cfo_isl_metrics'),

		entryPoint() {
			if (!fg('slt1-1341_site_optimizer_add_cfo_isl_metrics')) {
				return notFoundPageEntrypoint;
			}
			return issueSecurityLevelProjectLimitMetricDetailEntryPoint;
		},

		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalSystemSettings,
			menuId: MenuIdSettings,
		},

		resources: getIssueSecurityLevelProjectLimitResources(),

		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
